module.exports = __webpack_public_path__ + "img/lg_e.9aa2aa67.png";